export const PUBLIC_CV_PATH = '/cv'
